import type {FondedFieldType} from 'src/typings';
import type {FondFieldTypeDefinitions} from 'src/features/record/field-types/types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class FieldTypeDataService {

    public static readonly serviceName = 'fieldTypeDataService';
    private static readonly QUERY_BY_RECORD_EDITATION_ROUTE = 'field-types';
    private static readonly FOND_FIELD_TYPE_DEFINITIONS_ROUTE = 'field-types/fond-field-definitions';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async queryByRecordEditation(recordEditationId: string): Promise<FondedFieldType[]> {
        return this.ajaxService
            .createRequest(`${FieldTypeDataService.QUERY_BY_RECORD_EDITATION_ROUTE}`)
            .get({recordEditation: recordEditationId});
    }

    public async loadFondFieldTypeDefinitions(fondId: number): Promise<FondFieldTypeDefinitions> {
        return this.ajaxService
            .createRequest(`${FieldTypeDataService.FOND_FIELD_TYPE_DEFINITIONS_ROUTE}`)
            .get({fond: fondId});
    }
}